import React from "react";
import ReactPlayer from "react-player";
import "./VideoPlayer.css";

function VideoPlayer({ 
  url, 
  className = "", 
  maxWidth = "400px",
  maxHeight = "600px",
  aspectRatio = "9 / 16",
  children = null // Optional children (like stickers)
}) {
  return (
    <div className={`video-player-wrapper ${className}`} style={{ maxWidth, maxHeight, aspectRatio }}>
      <ReactPlayer
        url={url}
        controls
        width="100%"
        height="100%"
        className="video-player"
        config={{
          file: {
            attributes: {
              controlsList: 'nodownload'
            }
          }
        }}
      />
      {children}
    </div>
  );
}

export default VideoPlayer;

